var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a;
import { REACT_APP__URL_SMP_API } from "@smp/utils";
import { apiRequest } from "../../../lib";
export class ApiSmpPageSubscription {
}
_a = ApiSmpPageSubscription;
ApiSmpPageSubscription.list = (req) => __awaiter(void 0, void 0, void 0, function* () {
    return apiRequest({
        endpoint: REACT_APP__URL_SMP_API + `/page/v1/subscriptions/`,
        method: "GET",
        next: req === null || req === void 0 ? void 0 : req.next,
        query: req === null || req === void 0 ? void 0 : req.query,
    });
});
//# sourceMappingURL=subscription.js.map